import React, { ReactNode, useState } from 'react'
import Alert from '../../components/Alert'
import type { AlertData } from './AlertContext'
import { AlertContext, AlertType } from './AlertContext'

export const AlertProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [alert, setAlert] = useState<AlertData>({})

  const clearAlert = () => setAlert({})

  const showAlert = (newAlert: AlertData) => {
    setAlert({
      msg: newAlert.msg,
      severity: newAlert.severity || AlertType.INFO,
      duration: newAlert.duration,
    })
  }

  return (
    <AlertContext.Provider value={{ alert, showAlert, clearAlert }}>
      {children}
      <Alert
        duration={alert.duration || 5000}
        isOpen={!!alert?.msg}
        message={alert.msg || ''}
        severity={alert.severity || 'success'}
        onClose={() => {
          clearAlert()
        }}
      />
    </AlertContext.Provider>
  )
}
